import  { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import emailjs from "emailjs-com";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Image from "../assets/imgSect6.svg";

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    from_name: "",
    name: "",
    company: "",
    phone: "",
    email: "",
    message: "",
    reply_to: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

  // Inicializar EmailJS solo una vez
  useEffect(() => {
    emailjs.init("jztYMX5KHGG6apwia");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "email") {
      setErrors((prev) => ({
        ...prev,
        email: emailRegex.test(value) ? "" : t('contactForm.email_invalid'),
      }));
    }
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, phone: value }));
    setErrors((prev) => ({
      ...prev,
      phone:
        !value || value.replace(/\D/g, "").length < 8
          ? t('contactForm.phone_invalid')
          : "",
    }));
  };

  const isFormValid = () => {
    return (
      formData.name.trim() &&
      formData.company.trim() &&
      formData.phone.trim() &&
      formData.email.trim() &&
      !errors.phone &&
      !errors.email
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const btn = document.getElementById("button");
    btn.value = t('contactForm.sending');

    emailjs
      .sendForm(
        "service_8bq5k0l",
        "template_egxzi27",
        "#contact-form",
        "jztYMX5KHGG6apwia"
      )
      .then(
        () => {
          setIsSubmitted(true);
          btn.value = t('contactForm.sent');
          setFormData({
            from_name: "",
            name: "",
            company: "",
            phone: "",
            email: "",
            message: "",
            reply_to: "",
          });
        },
        (err) => {
          console.error("Error al enviar:", err);
          btn.value = t('contactForm.submit');
        }
      );
  };

  return (
    <section className="items-center text-center" id="contacto">
      <div className="divider-conteiner text-center space-y-0 mb:space-y-2 mt-8">
        <h1 className="font-sans text-secondary font-bold resp-h3">
          {t('contactForm.title')}
        </h1>
        <p className="font-content hero-p resp-h2" style={{ lineHeight: "130%" }}>
          {t('contactForm.subtitle')}
        </p>
      </div>

      <div className="flex flex-col md:flex-row items-center text-left py-8 px-20 mb:px-8 mb:py-10">
        <div className="w-full md:w-[60%] form-conteiner">
          <p className="font-content hero-p resp-h2 mt-4 text-left">
            {t('contactForm.lead')}
          </p>

          <form
            id="contact-form"
            className="w-[90%] space-y-4"
            onSubmit={handleSubmit}
          >
            {/* Campo oculto from_name (puede ser tu etiqueta o empresa) */}
            <input
              type="hidden"
              name="from_name"
              value={formData.from_name}
            />

            <input
              className="input-field font-poppins text-[14px]"
              type="text"
              name="name"
              placeholder={t('contactForm.name_placeholder')}
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitted}
            />

            <input
              className="input-field font-poppins text-[14px]"
              type="email"
              name="email"
              placeholder={t('contactForm.email_placeholder')}
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitted}
            />
            {errors.email && <p className="error-text">{errors.email}</p>}

            <div className="w-full">
              <PhoneInput
                country="co"
                value={formData.phone}
                onChange={handlePhoneChange}
                disabled={isSubmitted}
                placeholder={t('contactForm.phone_placeholder')}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                inputStyle={{
                  width: "100%",
                  height: "2.5rem",
                  fontSize: "14px",
                  borderRadius: "0.2rem",
                  border: "none",
                  backgroundColor: "#f7f6f6c4",
                }}
                buttonStyle={{
                  backgroundColor: "#e9e8e8c4",
                  borderRadius: "0.2rem",
                  border: "none",
                }}
              />

            </div>
            {errors.phone && <p className="error-text">{errors.phone}</p>}

            <input
              className="input-field"
              type="text"
              name="company"
              placeholder={t('contactForm.company_placeholder')}
              value={formData.company}
              onChange={handleChange}
              disabled={isSubmitted}
            />

            <textarea
              className="input-field"
              name="message"
              placeholder={t('contactForm.message_placeholder')}
              value={formData.message}
              onChange={handleChange}
              disabled={isSubmitted}
            />

            <input
              className="input-field"
              type="hidden"
              name="reply_to"
              value={formData.email}
            />

            <input
              className={`btn-primary ${isSubmitted ? "btn-disabled" : ""}`}
              style={{ fontSize: "clamp(12px, 1.2vw, 1.4vw)" }}
              type="submit"
              id="button"
              value={isSubmitted ? t('contactForm.sent') : t('contactForm.submit')}
              disabled={!isFormValid() || isSubmitted}
            />
          </form>
        </div>

        <div className="w-full md:w-[35%] img-conteiner mb:hidden">
          <img src={Image} alt="Gráfico" className="max-w-full h-auto" />
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
